module.exports = __webpack_public_path__ + "static/media/morphos_data_architecture.bf4e61fc.svg";